import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { TreatmentVariablesFormValues } from "./interface";

interface EditFieldsProps {
  formValues: TreatmentVariablesFormValues;
  handleChange: (
    field: keyof TreatmentVariablesFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Spiritual factors"
        value={formValues.spiritualFactors}
        onChange={handleChange("spiritualFactors")}
        helperText="Document details such as spiritual beliefs, practices, and any significant relationships that provide the client with support."
      />

      <LabeledTextArea
        multiline
        label="Cultural factors"
        value={formValues.culturalFactors}
        onChange={handleChange("culturalFactors")}
        helperText="Document cultural factors that could influence the client's care and treatment plan. Consider aspects like family dynamics, such as how decisions are made within the family, and any practices like physical discipline that may be used at home."
      />

      <LabeledTextArea
        multiline
        label="Legal factors"
        value={formValues.legalFactors}
        onChange={handleChange("legalFactors")}
        helperText="Document any legal factors related to the client that could impact their care management and treatment plan."
      />

      <LabeledTextArea
        multiline
        label="Linguistic factors"
        value={formValues.linguisticFactors}
        onChange={handleChange("linguisticFactors")}
        helperText="Document any linguistic factors related to the client that could impact their care management and treatment plan."
      />

      <LabeledTextArea
        multiline
        label="Community resources"
        value={formValues.communityResources}
        onChange={handleChange("communityResources")}
        helperText="Document community details that could influence the client’s care management and treatment plan."
      />
    </Grid>
  );
};

export default EditFields;
